// import Vue from 'vue'

export default [
  {
    path: '/EvCharging/',
    component: () => import('@/components/Layer.vue'),
    children: [
      // Root to TAB 1
      {
        path: '',
        redirect: { name: 'chargingDashboard' }
      },
      // TAB 1 => 儀表板
      {
        path: 'chargingDashboard',
        name: 'chargingDashboard',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 2 => 充電樁管理
      {
        path: 'connectorsManagement',
        name: 'connectorsManagement',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 3 => 充電紀錄
      {
        path: 'chargingRecord',
        name: 'chargingRecord',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 4 => 費率設定
      {
        path: 'rateSetting',
        name: 'rateSetting',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 5 => 代收帳單
      {
        path: 'chargingFeeList',
        name: 'chargingFeeList',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 6 => 管理費產單
      {
        path: 'managementFeeList',
        name: 'managementFeeList',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 7 => 充電樁歷史數據統計
      {
        path: 'connectorHistoryList',
        name: 'connectorHistoryList',
        component: () => import('@/views/EvCharging/EvCharging.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // 電費設定頁
      {
        path: 'rateSetting/chargingRateSetting/:summer?',
        name: 'chargingRateSetting',
        component: () => import('@/views/EvCharging/ChargingRateSetting.vue'),
        meta: {
          prev: 'rateSetting'
        }
      },
      // 逾時停車費設定頁
      {
        path: 'rateSetting/parkingRateSetting',
        name: 'parkingRateSetting',
        component: () => import('@/views/EvCharging/ParkingRateSetting.vue'),
        meta: {
          prev: 'rateSetting'
        }
      }
    ]
  }
]
